/**
 * The report module's paths — spec §8.9.
 *
 * `/reports` is what `layout/nav-items.ts` already points its `reports` entry at, gated on
 * `reports:read`, so the prefix is not a choice this phase makes. `/reports/schedules`
 * carries `reports:schedule` instead, and that split is the API's: scheduling sends fleet
 * data to an e-mail address, repeatedly, to somebody who may not have a RIVENA account
 * at all — the one operation in this module that moves data outside the login boundary.
 *
 * Route paths stay in English while the UI defaults to French, for the reason
 * `nav-items.ts` gives: the address bar is not a translated surface.
 */

export const REPORTS_PATH = '/reports'
export const REPORT_SCHEDULES_PATH = '/reports/schedules'
export const REPORT_RUNS_PATH = '/reports/runs'

export const REPORT_QUERY_KEYS = {
  /** Which catalogue entry the parameter form is open on. */
  key: 'key',
  /** A saved template's id — the form opens pre-filled from it. */
  definitionId: 'template',
  /** `YYYY-MM-DD` day keys in the TENANT's zone, inclusive at both ends. */
  from: 'from',
  to: 'to',
  format: 'format',
  /**
   * The run being watched. On the URL rather than in component state so that leaving the
   * page and coming back — or sending somebody the link — still lands on the same run,
   * which is what "generation returns a handle" has to mean for the person waiting.
   */
  runId: 'run',
} as const

export function reportFormPath(key: string): string {
  return `${REPORTS_PATH}?${REPORT_QUERY_KEYS.key}=${encodeURIComponent(key)}`
}

export function reportRunPath(runId: string): string {
  return `${REPORTS_PATH}?${REPORT_QUERY_KEYS.runId}=${encodeURIComponent(runId)}`
}
